<template>
  <v-card>
    <v-card-text v-if="contrato.id">
      <v-row>
        <v-col cols="12">
          Tipo de contrato: {{ contrato.tipo_contrato.descripcion }}
        </v-col>
        <v-col cols="12">
          Vigencia:  {{ vigencia }}
        </v-col>
        <v-divider />
        <v-col cols="12">
          Total: {{ contrato.total }}
        </v-col>
      </v-row>
      <v-divider />
      <base-material-tabs color="gold">
        <v-tab>
          Derechos
        </v-tab>
        <v-tab>
          Obligaciones
        </v-tab>
        <v-tab-item>
          <v-card flat class="my-0">
            <v-card-text class="px-0">
              <v-expansion-panels v-if="contrato.derecho_representante.length">
                <v-expansion-panel v-for="(value, key) in contrato.derecho_representante" :key="key">
                  <v-expansion-panel-header>
                    Derecho número: {{ key }} {{ derechoClubJugador(value) }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row style="overflow: auto; max-height:300px; min-height:150px;">
                      <v-col v-for="(itemValue, key2) in value.detalle_derecho_representante" :key="key2" cols="4" md="6">
                        <v-card>
                          <v-col cols="12" class="pb-0" :style="estiloDerechos(itemValue)">
                            <v-row justify="space-between" class="pl-0 ma-0">
                              <v-col cols="6" class="pa-0">
                                <span style="font-size: 1rem; displ">
                                  Cuota: {{ itemValue.cuota }}
                                </span>
                              </v-col>
                              <v-col v-if="!(itemValue.saldo === itemValue.monto) && (itemValue.monto_condonado === 0)" cols="1" class="pa-0">
                                <v-tooltip content-class="top" top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" @click="mostrarInfoCuota(itemValue, value.moneda_id)">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>Mostrar pagos</span>
                                </v-tooltip>
                              </v-col>
                              <v-col v-else-if="(itemValue.monto_condonado !== 0)" cols="1" class="pa-0">
                                <v-tooltip content-class="top" top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>Condonada</span>
                                </v-tooltip>
                              </v-col>
                              <v-col v-if="!visibilidad(itemValue.saldo) && $can('M_contratos_crear')" cols="1" class="pa-0">
                                <v-checkbox v-model="inputSelected" hide-details color="info" class="shrink mr-0 mt-0 pa-0" :value="itemValue.id" />
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" class="pb-0 pt-1">
                            <span style="font-size: 1rem"> Monto: {{ simboloMoneda(value.moneda_id) + ' ' + itemValue.monto }} </span>
                          </v-col>
                          <v-col cols="12" class="pb-0 pt-1">
                            <span style="font-size: 1rem"> Saldo: {{ simboloMoneda(value.moneda_id) + ' ' + itemValue.saldo }} </span>
                          </v-col>
                          <v-col cols="12" class="pt-1">
                            <span style="font-size: 1rem"> Venc.: {{ vencimiento(itemValue.vencimiento) }} </span>
                          </v-col>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div v-else>
                No existen derechos para este contrato
              </div>
              <v-row align="center" justify="center" class="mt-2">
                <v-btn v-show="aCobrarSeleted.length !== 0" color="gold" class="mr-2" @click="goToPagar">
                  Registrar pago
                </v-btn>
                <v-btn v-show="aCobrarSeleted.length !== 0" color="gold" class="ml-2" @click="confirmCondonacion">
                  Condonar cuotas
                </v-btn>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat class="my-0">
            <v-card-text class="px-0">
              <v-expansion-panels v-if="contrato.obligacion_representante.length">
                <v-expansion-panel v-for="(value, key) in contrato.obligacion_representante" :key="key">
                  <v-expansion-panel-header>
                    {{ value.obligacion.descripcion }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row style="overflow: auto; max-height:300px; min-height:150px;">
                      <v-col v-for="(itemValue, key2) in value.detalle_obligacion_representante" :key="key2" cols="4" md="6">
                        <v-card>
                          <v-col cols="12" class="pb-0" :style="estiloObligaciones(itemValue)">
                            <v-row>
                              <v-spacer></v-spacer>
                              <v-col v-if="(itemValue.pagos_id || itemValue.valor_monetario)" cols='2' class="pa-0">
                                <v-tooltip content-class="top" top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" @click="mostrarInfoObligacion(itemValue)">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>Mostrar pagos</span>
                                </v-tooltip>
                              </v-col>
                              <v-col v-else-if="(itemValue.condonada_sn)" cols='2' class="pa-0">
                                <v-tooltip content-class="top" top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">
                                      mdi-information-outline
                                    </v-icon>
                                  </template>
                                  <span>Condonada</span>
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" class="pb-0">
                            <v-row justify="space-between" class="pl-0 ma-0">
                              <v-col cols="6" class="pa-0">
                                <span style="font-size: 1rem"> Cantidad: {{ itemValue.cantidad }} </span>
                              </v-col>
                              <v-col v-if="visibilidadObligacion(itemValue) && $can('M_contratos_crear')" cols="1" class="pa-0">
                                <v-checkbox v-model="inputSelectedObligacion" hide-details color="info" class="shrink mr-0 mt-0 pa-0" :value="itemValue.id" />
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" class="pb-0 pt-1">
                            <span style="font-size: 1rem"> Vencimiento: {{ itemValue.vencimiento }} </span>
                          </v-col>
                          <v-col cols="12" class="pt-1">
                            <span style="font-size: 1rem"> Pago: {{ (itemValue.pagos_id === null) ? 'No' : 'Si' }} </span>
                          </v-col>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <div v-else>
                No existen obligaciones para este contrato
              </div>
              <v-row align="center" justify="center" class="mt-2">
                <v-btn v-show="aPagarSelected.length !== 0" color="gold" class="mr-2" @click="goToPagarObligacion">
                  Cancelar cuotas
                </v-btn>
                <v-btn v-show="aPagarSelected.length !== 0" color="gold" class="ml-2" @click="confirmCondonacionObligacion">
                  Condonar cuotas
                </v-btn>
              </v-row>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </base-material-tabs>
    </v-card-text>
    <confirm ref="confirmCT" />
    <datosCuotas :simbolo-moneda="simboloMoneda(cuotaInfo.moneda_id)" :cuota="cuotaInfo" :toggle="dialogCuota" class="mr-0 mt-0 pa-0" style="display: inline" />
    <datosObligaciones :obligacion="obligacionInfo" :toggle="dialogObligacion" class="mr-0 mt-0 pa-0" style="display: inline" />
  </v-card>
</template>

<script>
  import confirm from '../../components/confirm'
  import datosCuotas from '../../components/InformacionCuota'
  import datosObligaciones from '../../components/InformacionObligacion'

  export default {
    name: 'Contratos',
    components: {
      confirm,
      datosCuotas,
      datosObligaciones,
    },
    props: {
      contrato: {
        type: Object,
        default: () => ({
          total: undefined,
          valido_desde: undefined,
          valido_hasta: undefined,
          id: undefined,
        }),
      },
      monedas: {
        type: Array,
        required: false,
        default: () => [],
      },
      index: {
        type: Number,
        required: true,
        default: 0,
      },
    },
    data () {
      return {
        datosContrato: [],
        inputSelected: [],
        inputSelectedObligacion: [],
        aCobrarSeleted: [],
        aPagarSelected: [],
        colorVerde: 'background-color: #ABFD99',
        colorAmarillo: 'background-color: #FDFD96',
        noVisible: 'visibility: hidden',
        colorBlanco: 'color: "#ABFD99"',
        idDerechoSelected: 0,
        idObligacionSelected: 0,
        dialogCuota: true,
        dialogObligacion: true,
        cuotaInfo: {
          moneda_id: 1,
        },
        obligacionInfo: {
          moneda_id: 1,
        },
      }
    },
    computed: {
      vigencia () {
        return this.contrato.valido_desde + ' / ' + this.contrato.valido_hasta
      },
      rescindido () {
        return (this.contrato) ? ((this.contrato.rescindido_sn) ? 'Si' : 'No') : ''
      },
    },
    watch: {
      inputSelected (val) {
        const idNuevo = this.getIdDerechoFromCuota(val[val.length - 1])
        this.idDerechoSelected = idNuevo
        if (Object.keys(this.aCobrarSeleted).length !== 0) {
          const idAnterior = this.getIdDerechoFromCuota(val[0])
          if (idNuevo !== idAnterior) {
            this.inputSelected = []
            this.inputSelected.push(val[val.length - 1])
          }
        }
        this.aCobrarSeleted = val
      },
      inputSelectedObligacion (val) {
        const idObliSelect = this.getIdObligacionFromCuota(val[val.length - 1])
        if (Object.keys(this.aPagarSelected).length !== 0) {
          if (idObliSelect !== this.idObligacionSelected) {
            this.inputSelectedObligacion = []
            this.inputSelectedObligacion.push(val[val.length - 1])
          }
        }
        this.idObligacionSelected = idObliSelect
        this.aPagarSelected = val
      },
    },
    created () {
    },
    methods: {
      estiloDerechos (derecho) {
        if (derecho.monto === derecho.monto_condonado) {
          return this.colorAmarillo
        }
        if (derecho.saldo === 0) {
          return this.colorVerde
        }
        return this.colorBlanco
      },
      estiloObligaciones (obligacion) {
        if (obligacion.condonada_sn) {
          return this.colorAmarillo
        }
        if (obligacion.pagos_id || obligacion.valor_monetario) {
          return this.colorVerde
        }
        return this.colorBlanco
      },
      visibilidadObligacion (obligacion) {
        return (!(obligacion.valor_monetario !== 0 || obligacion.condonada_sn === 1 || obligacion.pagos_id !== null))
      },
      mostrarInfoCuota (Cuota, monedaId) {
        this.cuotaInfo = Cuota
        this.cuotaInfo.moneda_id = monedaId
        this.dialogCuota = !this.dialogCuota
      },
      mostrarInfoObligacion (obligacion) {
        this.obligacionInfo = obligacion
        this.dialogObligacion = !this.dialogObligacion
      },
      confirmCondonacion () {
        this.$refs.confirmCT.open('Alerta', 'Está seguro que desea condonar la cuota? No se podra revertir', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.condonarCuotas()
          }
        })
      },
      confirmCondonacionObligacion () {
        this.$refs.confirmCT.open('Alerta', 'Está seguro que desea condonar la cuota? No se podra revertir', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.condonarCuotasObligacion()
          }
        })
      },
      condonarCuotasObligacion () {
        const aux = this.aPagarSelected
        this.$http({ method: 'put', url: '/api/obligacion_condonar', data: { cuotas: aux } })
          .then(response => {
            this.$store.commit('toast/show', { tipo: 'success', messages: ['Condonacion exitosa'] })
            this.aPagarSelected = []
            this.inputSelectedObligacion = []
            this.$emit('cuotasCondonadas', this.index)
          }).catch(error => {
            if (error.response.data.errors) {
              this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
            } else {
              this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
            }
          })
      },
      condonarCuotas () {
        const aux = this.aCobrarSeleted
        this.$http({
          method: 'put',
          url: '/api/derechos_condonar',
          data: {
            cuotas: aux,
          },
        }).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Condonacion exitosa'] })
          this.aCobrarSeleted = []
          this.inputSelected = []
          this.$emit('cuotasCondonadas', this.index)
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
      },
      simboloMoneda (monedaid) {
        return (this.monedas.length !== 0 && this.contrato.derecho_representante !== null) ? this.monedas.find(e => e.id === monedaid).simbolo : '$'
      },
      getIdDerechoFromCuota (idLastDerecho) {
        let idDerechoCuotaSelec = undefined // eslint-disable-line no-undef-init
        for (let i = 0; i < this.contrato.derecho_representante.length && idDerechoCuotaSelec === undefined; i++) {
          const aux2 = this.contrato.derecho_representante[i].detalle_derecho_representante.find(e => e.id === idLastDerecho)
          if (aux2 !== undefined) {
            idDerechoCuotaSelec = this.contrato.derecho_representante[i].id
          }
        }
        return idDerechoCuotaSelec
      },
      getIdObligacionFromCuota (idLastCuotaO) {
        for (let i = 0; i < this.contrato.obligacion_representante.length; i++) {
          const aux = this.contrato.obligacion_representante[i].detalle_obligacion_representante.find(e => e.id === idLastCuotaO)
          if (aux) {
            return this.contrato.obligacion_representante[i].id
          }
        }
        return null
      },
      goToPagar: function (index) {
        this.$store.commit('dep/setCuotas', { payload: this.aCobrarSeleted })
        this.$router.push({ name: 'Cobros', params: { id: 0, mode: 'precargado', idJugador: this.contrato.jugador_id, idContrato: this.contrato.id, idDerecho: this.idDerechoSelected } })
      },
      goToPagarObligacion: function () {
        this.$store.commit('dep/setCuotas', { payload: this.aPagarSelected })
        this.$router.push({ name: 'Pagos', params: { id: 0, mode: 'precargado', idJugador: this.contrato.jugador_id, idContrato: this.contrato.id, idObligacion: this.idObligacionSelected } })
      },
      visibilidad: function (saldo) {
        return (saldo === 0) // ? 'visibility: hidden; display: inline' : 'display: inline'
      },
      vencimiento: function (fecha) {
        return fecha
      },
      derechoClubJugador: function (derechoRepresentante) {
        let derechoSobre = ''
        if (derechoRepresentante.club_id !== null) {
          derechoSobre = 'sobre el club'
        } else if (derechoRepresentante.jugador_id !== null) {
          derechoSobre = 'sobre el jugador'
        }
        return derechoSobre
      },
    },
  }
</script>
